export default __webpack_public_path__ + "static/media/2.dde1da42.png";